import React from "react";
import GitHubIcon from '@mui/icons-material/GitHub';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import '../assets/styles/Footer.scss';
import { PortfolioContent } from '../data/content';

interface FooterProps {
  content: PortfolioContent['footer'];
  social: PortfolioContent['main']['social'];
}

function Footer({ content, social }: FooterProps) {
  return (
    <footer>
      <div className="footer-social">
        {social.github && (
          <a
            href={social.github}
            target="_blank"
            rel="noreferrer"
            title={`GitHub: ${social.github}`}
          >
            <GitHubIcon />
          </a>
        )}
        {social.linkedin && (
          <a
            href={social.linkedin}
            target="_blank"
            rel="noreferrer"
            title={`LinkedIn: ${social.linkedin}`}
          >
            <LinkedInIcon />
          </a>
        )}
        {social.email && (
          <a
            href={`mailto:${social.email}`}
            title={`Email: ${social.email}`}
          >
            <EmailIcon />
          </a>
        )}
      </div>
      <p>{content.copyright}</p>
    </footer>
  );
}

export default Footer;